import { Component, OnInit } from '@angular/core';
import Utils from '../helpers/Utils';

@Component({
    selector: 'app-home',
    templateUrl: './home.component.html',
    styleUrls: ['./home.component.scss'],
    standalone: false
})
export class HomeComponent implements OnInit {
  bookType : string;
  ngOnInit() {
    this.bookType = Utils.getBookType();
  }
}
